import { createAction, props } from '@ngrx/store';

import { UserListActionTypes } from './actions.model';

export const init = createAction(UserListActionTypes.Init);

export const viewMoreClicked = createAction(
  UserListActionTypes.ViewMoreClicked
);

export const listViewTypeChanged = createAction(
  UserListActionTypes.ListViewTypeChanged,
  props<{ viewType: string }>()
);

export const filtersChanged = createAction(
  UserListActionTypes.FiltersChanged,
  props<{ filter: Record<string, any> }>()
);
